/* eslint-disable no-restricted-syntax */
import 'react-table/react-table.css';
import React from 'react';
import { I18n } from 'react-redux-i18n';
import NumberFormat from 'react-number-format';
import FormatHelpers from '../../../helpers/format';

export default class ProductsList extends React.Component {
  validCheckbox = () => {
    const { selectedCheckbox } = this.props;
    const outboundOrderProductIds = [];
    if (Object.keys(selectedCheckbox).length) {
      for (const index in selectedCheckbox) {
        if (selectedCheckbox[index]) outboundOrderProductIds.push(index);
      }
    }
    this.props.setOutboundOrderProductIds(outboundOrderProductIds);
  };

  changeItemPickedQuantity = (id, value) => {
    const { products } = this.props;

    if (!Array.isArray(products) || products.length === 0) return;

    const index = products.findIndex((product) => product.outboundOrderProductId === id);

    if (index === -1) return;

    const updatedProducts = products.map((product, i) => (
      i === index ? { ...product, newPickedQuantity: value } : product
    ));

    this.props.setProducts(updatedProducts);
  };

  singleSelection = (selection) => {
    const { selectedCheckbox } = this.props;
    selectedCheckbox[selection.outboundOrderProductId] = !selectedCheckbox[selection.outboundOrderProductId];
    this.props.setSelectedCheckbox(selectedCheckbox);
    this.validCheckbox();
  };

  multipleSelection = (selectionOption) => {
    const { products, selectedCheckbox } = this.props;
    if (products && products.length > 0) {
      for (const element of products) {
        if (selectedCheckbox[element.outboundOrderProductId] !== selectionOption && element.productStatus < 10
          && element.pickedQuantity !== '' && parseFloat(element.pickedQuantity) !== 0) {
          selectedCheckbox[element.outboundOrderProductId] = selectionOption;
        }
      }
      this.props.setSelectedCheckbox(selectedCheckbox);
      this.validCheckbox();
    }
  };

  createNumberFormat = (value, attr, decimals, disabled = false, keypressFunction = undefined, id = null) => (
    <div className="form-group p-2 text-left">
      <div className="input-group">
        <NumberFormat
          onKeyDown={keypressFunction ? ((e) => keypressFunction(e, id, attr)) : undefined}
          id={id && id}
          className="form-control"
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={(this.props.mainBranchData
            && this.props.mainBranchData.company
            && this.props.mainBranchData.company.fractionalQuantity === false)
            ? 0
            : decimals}
          value={(value === 0 || value) ? value : ''}
          onValueChange={(values) => {
            this.changeItemPickedQuantity(id, values.floatValue);
          }}
          fixedDecimalScale
          defaultValue={0}
          disabled={disabled}
          allowEmptyFormatting
        />
      </div>
    </div>
  );

  render() {
    const { products } = this.props;
    const { serialControlDeposit } = this.props.mainBranchData || {};

    return (
      <div>
        <div className="row">
          <div className="col text-right">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.multipleSelection(true)}
            >
              {I18n.t('BEE1908' /* Marcar Todos */)}
            </button>
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.multipleSelection(false)}
            >
              {I18n.t('BEE1909' /* Desmarcar Todos */)}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="table-responsive">
            <table className="table table-bordered widget-table widget-table-rounded">
              <thead>
                <tr className="text-center f-s-12">
                  <th width="5%">{I18n.t('BEE463' /* Linha */)}</th>
                  <th width="50%">{I18n.t('BEE225' /* Produto */)}</th>
                  <th width="15%">{I18n.t('BEE442' /* Lotes */)}</th>
                  <th width="15%">{I18n.t('BEE1134' /* Quantidade Separada */)}</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => {
                  if (product.productStatus < 10
                    && product.pickedQuantity !== ''
                    && parseFloat(product.pickedQuantity) !== 0) {
                    return (
                      <tr className="text-center" key={index}>
                        <td>
                          <h5>{product.lineNumber}</h5>
                          <br />
                          <p>
                            <input
                              type="checkbox"
                              checked={this.props.selectedCheckbox[product.outboundOrderProductId] || false}
                              onChange={() => this.singleSelection(product)}
                            />
                          </p>
                        </td>
                        <td className="text-left">
                          <h4 className="widget-table-title">{product.productCode}</h4>
                          <p className="widget-table-desc m-b-15">{product.productName}</p>
                          <p className="widget-table-desc m-b-15">{product.productFullName}</p>
                        </td>
                        <td>
                          {product.lotNumber}
                        </td>
                        <td>
                          {!serialControlDeposit ? this.createNumberFormat(
                            product.newPickedQuantity !== undefined
                              ? parseFloat(product.newPickedQuantity)
                              : parseFloat(product.pickedQuantity || 0),
                            'pickedQuantity',
                            4,
                            false,
                            undefined,
                            product.outboundOrderProductId,
                          ) : FormatHelpers.formatNumber(product.pickedQuantity, 4)}
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
